import type { FC } from 'react';
import { Suspense } from 'react';

import reactLazyWithRetry from '@fatso83/retry-dynamic-import/react-lazy';
import * as Sentry from '@sentry/react';

import { useAuth } from 'shared/lib/auth/useAuth';

import { useInkeepConfig } from './useInkeepConfig';

const InkeepChatButtonComponent = reactLazyWithRetry(() => import('./inkeepChatButtonModule'));

export const InkeepChat: FC = () => {
  const { isAuthenticated } = useAuth();
  const config = useInkeepConfig();

  if (!(isAuthenticated && config.baseSettings?.apiKey)) {
    return null;
  }

  return (
    <Sentry.ErrorBoundary fallback={<></>}>
      <Suspense fallback={null}>
        <InkeepChatButtonComponent {...config} />
      </Suspense>
    </Sentry.ErrorBoundary>
  );
};
